import {useEffect} from 'react'

import eventTracker from './EventTracker'

export default function useEvents() {
  useEffect(() => {
    eventTracker.init()
  }, [])
  return null
}

export const WithEvents = ({children}) => {
  useEvents()
  return children
}
